import type { RunnerResultType } from '@ps/web-sports-api-types';
import classNames from 'clsx';
import React from 'react';

import { type OddsChange, OddsChangeDirection } from '@swf/sports/hooks/useSelectionWatcher';
import { getHandicapSelectionValue } from '@swf/sports/utils/getHandicapSelectionValue';

import Content from '../Content/Content';

import styles from './Button.scss';

export interface ButtonProps {
  className?: string;
  isMultiline?: boolean;
  isStartingPriceMarket?: boolean;
  selectionText?: string;
  size?: 'small' | 'base';
}

interface OwnProps {
  isDisabled?: boolean;
  isLocked: boolean;
  isNonRunner?: boolean;
  isVacantTrap?: boolean;
  oddsHistory: OddsChange[];
  onClick: () => void;
  runnerResultType?: RunnerResultType;
  selected: boolean;
  shouldAnimate: boolean;
  shouldShowAddedToBetSlip?: boolean;
}

type Props = ButtonProps & OwnProps;

export const Button: React.FC<Props> = (props) => {
  const {
    className,
    isDisabled,
    isLocked,
    isMultiline,
    isNonRunner,
    isStartingPriceMarket = false,
    isVacantTrap,
    oddsHistory,
    onClick,
    runnerResultType,
    selected,
    selectionText,
    shouldAnimate,
    size,
    shouldShowAddedToBetSlip
  } = props;

  return (
    <button
      type="button"
      className={classNames(styles.selection, className, {
        [styles.selected]: selected,
        [styles.sizeSm]: size === 'small'
      })}
      onClick={onClick}
      data-testid="selection"
      disabled={isDisabled}
      aria-pressed={selected}
    >
      <span className={styles.oddsAnimationWrapper}>
        {oddsHistory.map((price, index) => {
          const isFirst = index === 0;

          return (
            <span
              key={price.time}
              aria-hidden={oddsHistory.length > 1 && index !== oddsHistory.length - 1}
              className={classNames(styles.odds, {
                [styles.decrease]:
                  shouldAnimate && !isFirst && price.direction === OddsChangeDirection.Decrease,
                [styles.increase]:
                  shouldAnimate && !isFirst && price.direction === OddsChangeDirection.Increase,
                [styles.locked]: isLocked,
                [styles.multiline]: isMultiline,
                [styles.sizeSm]: size === 'small'
              })}
            >
              <Content
                odds={price.odds}
                isLocked={isLocked}
                selectionText={
                  price.handicap !== 0
                    ? getHandicapSelectionValue({
                        handicap: price.handicap,
                        runnerResultType
                      })
                    : selectionText
                }
                isNonRunner={isNonRunner}
                isStartingPriceMarket={isStartingPriceMarket}
                isHandicap={price.handicap !== 0}
                isVacantTrap={isVacantTrap}
                shouldShowAddedToBetSlip={shouldShowAddedToBetSlip}
              />
            </span>
          );
        })}
      </span>
    </button>
  );
};
